import React, {useState, useEffect} from 'react';
import {connect} from "react-redux";
import * as authActions from "../pages/AuthContainer/auth.reducer";
import * as cartActions from "../../actions";
import Spinner from "../shop/Spinner";

function LandingOverlay( props ) {
    const [isJWTChecked, setIsJWTChecked] = useState(false);
    useEffect(() => {
        if(!props.token){
            props.authCheckState((bool) => setIsJWTChecked(bool));
            props.getCartItems()
            props.getWatchLists()
        }
    }, []);

    if(!isJWTChecked) return <Spinner/>
    return (
        <div className="loading-overlay">
            <div className="root-loader bounce-loader">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        userRole: state.auth.userRole,
        token: state.auth.token
    };
}

const mapDispatchToProps = dispatch => {
    return {
        authCheckState: (isJWTChecked, router) => dispatch(authActions.authCheckState(isJWTChecked, router)),
        getCartItems: () => dispatch(cartActions.getCartItems()),
        getWatchLists: () => dispatch(cartActions.getWatchLists())
    }
}

export default React.memo( connect(mapStateToProps, mapDispatchToProps)(LandingOverlay) );